<div [ngClass]="{ 'box-selected': isSelected, 'box-mobile': isSmall, 'box-error': isError, 'box-selected-consent-card': isXMCCardSelected }" class="box">
    <xm-media-image [ngClass]="{ 'check-visible': isSelected, 'check-mobile': isSmall, 'check-visible-consent-card': isXMCCardSelected }" class="check"  size="auto" aria-hidden="true" [imageOptions]="backgroundImage"></xm-media-image>
</div>
